import { composeIO } from 'react-compose-io'
import { GraficoValorQuantidadeMultiploView } from './GraficoValorQuantidadeMultiplo.View'
import { graficoValorQuantidadeMultiploIO } from './GraficoValorQuantidadeMultiplo.IO'

export const GraficoValorQuantidadeMultiplo = composeIO(GraficoValorQuantidadeMultiploView, graficoValorQuantidadeMultiploIO)
